module.exports = __webpack_public_path__ + "static/img/app3.8ba06f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/soft/app3.jpg
// module id = CSdi
// module chunks = 0